<template>
  <div class="auth-wrap">
    <div style="text-align: center;margin-bottom:30px;font-weight: bold">{{$t('ProductInfo.loginTip')}}</div>
    <van-form ref="form" validate-first>
      <div class="flex flex-row items-center "
           style="background: #282828;border-radius: 10px">
        <!--label="+61" -->
        <van-popover
            v-model="showPopover"
            trigger="click"
            :actions="actions"
            theme="dark"
            placement="bottom-start"
            @select="onPhoneIdentifiedSelect"
        >
          <template #reference>
            <span style="font-size: 14px;margin-left:14px">{{ loginData.identification }}</span>
          </template>
        </van-popover>
        <van-field v-model="loginData.phone" type="phone" name="phone"
                   :placeholder="$t('ProductInfo.phone')"
                   :rules="rules.phone">
        </van-field>
      </div>

      <div>
        <van-field
            v-model="loginData.code"
            type="number"
            maxlength="6"
            :placeholder="$t('ProductInfo.EnterCaptcha')"
            :rules="rules.code">
          <template #button>
            <van-button native-type="button" size="small" name="code"
                        class="normal-round"
                        color="#ed6c10"
                        type="primary"
                        @click="onGetCaptcha"
                        :disabled="captchaDisabled">
              {{ codeTips }}
            </van-button>
          </template>
        </van-field>
      </div>
    </van-form>



    <van-button @click="onLoginClick" color="#ed6c10" class="auth-button"
    >{{ $t('ProductInfo.Login') }}
    </van-button>
  </div>
</template>


<script>
import {mapState} from "vuex";
import {Toast} from "vant";
import user from "../api/user";

export default {
  name: "JzzLoginComponent",
  data() {
    return {
      loginData: {
        identification: '+86',
        phone: '',
        password: '',
        // email: '',
        // password: ''
      },

      actions: [{text: '+86'}],

      showPopover: false,
      passwordInputType: 'password',
      showPassword: false,
      rules: {},
      iconShowPassword: require('@/assets/logo/show-password.png'),
      codeTips: '',
      seconds: 60,
      countDownId: -1,
      disabled: false,
    }
  },
  created() {
    document.body.style.background = '#111111'
    this.codeTips = this.$t('ProductInfo.GetCode')
    this.rules = {
      phone: [{required: true, messages: this.$t('ProductInfo.phone')}],
      code: [{required: true, messages: this.$t('ProductInfo.EnterCaptcha')}],
    }
  },
  computed: {
    ...mapState("cartridge", ["deviceInfo"]),
    captchaDisabled() {
      return this.disabled && this.loginData.phone >= 10
    },

    registered() {
      return !!this.deviceInfo.status
    },
  },
  methods: {
    onPhoneIdentifiedSelect(e) {
      this.loginData.identification = e.text
    },

    toRegister() {
      this.$router.replace({
        name: 'Register',
        query: {
          redirect: this.$route.query.redirect
        }
      })
    },

    toFindPassword() {
      this.$router.push({
        name: 'Forget',
        query: {
          redirect: this.$route.query.redirect
        }
      })
    },
    onShowHidePassword() {
      this.showPassword = !this.showPassword
      if (this.showPassword) {
        this.passwordInputType = 'text'
      } else {
        this.passwordInputType = 'password'
      }
    },
    async onLoginClick() {
      this.$refs.form.validate().then(async (result) => {
        const {phone, code, identification} = this.loginData

        try {
          await this.$store.dispatch("user/login", {phone, verificationCode: code, identification});
          await this.$store.dispatch("cartridge/updateBindStatus")
          if (!this.registered) {
            try {
              await this.$store.dispatch("cartridge/directRegisterCurrentSessionDevice")
            }catch (e) {
              // this.$router.replace(`${this.$route.query.redirect}`);
            }

          } else {
            // this.$router.replace(`${this.$route.query.redirect}`);
          }

        } catch (e) {
          this.$toast({
            message: e.message
          })
        }

      }).catch((e) => {
        console.log(e)
        this.$toast({
          message: e
        })
      }).finally(() => {
      });

    },
    async onGetCaptcha(e) {
      if (!this.loginData.phone) {
        Toast.fail({
          message: this.$t('ProductInfo.phone')
        })
      }

      const {phone, identification} = this.loginData

      try {
        const resp = await user.sendVerificationCode({
          phone,
          identification: identification.replace("+", ""),
        });
        if (resp.code === 200) {

          this.disabled = true;
          this.codeTips = `${this.seconds} S`
          this.countDownId = setInterval(() => {
            --this.seconds
            if (this.seconds === 0) {
              clearInterval(this.countDownId);
              this.countDownId = -1
              this.disabled = false
              this.seconds = 60
              this.codeTips = this.$t('ProductInfo.GetCode');
              return
            }
            this.codeTips = `${this.seconds} S`
          }, 1000)
        }
        this.$toast(resp.message)
      } catch (e) {
        this.disabled = false
        console.log(e)
      }
    }
  }
}
</script>

<style scoped lang="less">
.auth-wrap {
  color: white;
  padding: 0px 15px 15px 15px;
}

::v-deep .van-cell {
  margin-top: 10px;
  background: #282828;
  border-radius: 10px;
  color: #BBBBBB;
  align-items: center;

  .van-field__label {
    width: auto;
    display: flex;
    font-weight: bold;
    flex-direction: row;
    align-items: center;
    text-align: center;
  }
}

.auth-button {
  width: 100%;
  border-radius: 8px;
  margin-top: 24px;
  color: white;
  background: #0075FF;
}

.user-account-text {
  font-size: 14px;

}

.sign-up {
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
}
</style>